import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './HeroCarousel.css';
import PixieDust from './PixieDust';

const ChevronLeft = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRight = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: '/images/1.png',
      eyebrow: 'Disney Travel Expert',
      title: 'Magically Mousebound',
      subtitle: 'Making Disney dreams come true, one family at a time.',
      buttonText: 'Start Planning',
      buttonLink: '/blog',
    },
    {
      image: '/images/2.png',
      eyebrow: 'Tips & Guides',
      title: 'Disney Travel Tips',
      subtitle: 'Expert advice for your most magical vacation yet.',
      buttonText: 'Read Our Blog',
      buttonLink: '/blog',
    },
    {
      image: '/images/3.png',
      eyebrow: 'Stay in the Know',
      title: 'Stay Connected',
      subtitle: 'Get the latest Disney news and exclusive offers.',
      buttonText: 'Subscribe Now',
      buttonLink: '/contact',
    },
    {
      image: '/images/4.png',
      eyebrow: 'Let\'s Plan Together',
      title: 'Plan Your Adventure',
      subtitle: 'Let us help you create memories that last a lifetime.',
      buttonText: 'Contact Us',
      buttonLink: '/contact',
    },
  ];

  const goToSlide = useCallback((index) => {
    setCurrentSlide((index + slides.length) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="hero-carousel" aria-label="Featured highlights">
      <PixieDust count={12} />
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
            aria-hidden={index !== currentSlide}
          >
            <div className="carousel-overlay">
              <div className="carousel-content">
                <span className="carousel-eyebrow">{slide.eyebrow}</span>
                <h1 className="carousel-title">{slide.title}</h1>
                <p className="carousel-subtitle">{slide.subtitle}</p>
                <Link to={slide.buttonLink} className="carousel-cta">
                  {slide.buttonText}
                </Link>
              </div>
            </div>
          </div>
        ))}

        <button
          className="carousel-arrow carousel-arrow-prev"
          onClick={() => goToSlide(currentSlide - 1)}
          aria-label="Previous slide"
        >
          <ChevronLeft />
        </button>
        <button
          className="carousel-arrow carousel-arrow-next"
          onClick={() => goToSlide(currentSlide + 1)}
          aria-label="Next slide"
        >
          <ChevronRight />
        </button>

        <div className="carousel-indicators" role="tablist" aria-label="Slide navigation">
          {slides.map((_, index) => (
            <button
              key={index}
              role="tab"
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
              aria-selected={index === currentSlide}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
